import {useCallback, useEffect, useState} from "react";
import useCallDataApi from "../hooks/data";
import {Box, Modal} from "@mui/material";
import Popup from "../components/Popup";


export const PopupWrapper = ({ children }) => {
    const [popups, setPopups] = useState([]);
    const [dismissedIds, setDismissedIds] = useState([]);
    const { getData: fetchPopups } = useCallDataApi("popups");

    // Fetch popups
    useEffect(() => {
        fetchPopups().then((data) => {
            if (Array.isArray(data)) {
                setPopups(data);
            }
        });
    }, []);

    const dismissPopup = useCallback((id) => {
        setDismissedIds((prev) => {
            return [...prev, id];
        });
    }, []);

    // Determine if popups should be shown based on URL
    const shouldShowPopups = !window.location.pathname.startsWith("/payment-result");

    const visiblePopups = shouldShowPopups
        ? popups.filter((popup) => !dismissedIds.includes(popup.id))
        : [];


    return (
        <>
            {children}

            {visiblePopups.map((popup) => (
                <Modal
                    open
                    onClose={() => dismissPopup(popup.id)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Box
                        sx={{
                            width: {
                                xs: '90vw',   // mobile
                                sm: '80vw',      // tablet
                                md: '70vw',      // desktop
                            },
                            maxWidth: '100%',
                            outline: 'none'
                        }}
                    >
                        <Popup
                            title={popup.title}
                            image={popup.image}
                            content={popup.content}
                            onClose={() => dismissPopup(popup.id)}
                        />
                    </Box>
                </Modal>
            ))}
        </>
    );
};
